// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__126XQ","inputDescription":"styles_inputDescription__186J8"};